export enum BreadcrumbCategory {
  Component = 'component',
  GraphNavigation = 'graph navigation',
}
